import { render, staticRenderFns } from "./AddEditService.vue?vue&type=template&id=27e54561&scoped=true&"
import script from "./AddEditService.vue?vue&type=script&lang=js&"
export * from "./AddEditService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e54561",
  null
  
)

export default component.exports